import { SubscribeForm } from "#/components/subscribe/SubscribeForm.js";
import { Toaster } from "#/components/subscribe/Toaster.js";
import { createT } from "#/lib/i18n.js";
import { isLocaleCode } from "#/lib/i18n/locales.js";
import type { SubscriberLocale } from "@hantavirus/shared";

type Props = { locale: string };

export { Page };

function Page({ locale }: Props) {
  const t = createT(locale, "subscribe");
  const safeLocale: SubscriberLocale = isLocaleCode(locale) ? locale : "en";
  const dir = locale === "ar" ? "rtl" : "ltr";

  return (
    <>
      <main id="main-content" className="mx-auto max-w-2xl px-4 py-12">
        <header className="mb-8 flex flex-col gap-2">
          <h1 className="text-3xl font-semibold text-[color:var(--color-fg-default)]">
            {t("page.title")}
          </h1>
          <p className="text-base text-[color:var(--color-fg-muted)]">
            {t("page.subtitle")}
          </p>
        </header>
        <SubscribeForm locale={safeLocale} t={t} />
      </main>
      <Toaster dir={dir} />
    </>
  );
}
